module.exports = __webpack_public_path__ + "img/3571e9b.jpg";